import * as styles from "./DialogClose.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";
import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";

import type { DialogCloseProps } from "./Dialog.types";

export function DialogClose({
  className,
  children,
  ...props
}: DialogCloseProps): JSX.Element {
  return (
    <BaseDialog.Close
      data-slot="dialog-close"
      className={clsx(styles.closeButton, className)}
      render={
        <Button variant="ghost" size="md" aria-label="Close">
          <Icon name="X" size="md" />
        </Button>
      }
      {...props}
    >
      {children}
    </BaseDialog.Close>
  );
}
